/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { ComponentProps } from 'preact';

import { Menu } from '../../UNSAFE_Menu';

export const initialMenuProps: MenuProps = {
  isOpen: false,
  initialFocus: 'menu',
  placement: 'bottom-start',
  offsetValue: 0,
  anchorRef: { current: null }
};

export type MenuProps = Pick<
  ComponentProps<typeof Menu>,
  'anchorRef' | 'initialFocus' | 'placement' | 'offsetValue' | 'isOpen'
>;
